var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAtlassian(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.55 36.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_atlassian") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.53,42.46H30a1.92,1.92,0,0,1-2-1.2C26,37.2,23.81,33.2,22,29A23.22,23.22,0,0,1,23.32,7c.25-.43.79-1,1.2-1s.9.57,1.12,1L42.25,40.21c.82,1.6.44,2.24-1.38,2.26Zm-22.21,0H7.69c-1.59,0-1.94-.63-1.24-2Q10.71,32,14.91,23.59c.76-1.59,1.36-1.59,2.42-.27a18.61,18.61,0,0,1,3.82,17c-.52,2-.8,2.14-2.84,2.14Z",
    transform: "translate(-6.11 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAtlassian);
export default __webpack_public_path__ + "static/media/ic_atlassian.4570211042bc80b3a19ada113830c8ef.svg";
export { ForwardRef as ReactComponent };